import useComplaintBaseActions from './useComplaintBaseActions'

export default useComplaintBaseActions
